<template>
  <b-col
    align-self="center"
    class="tw-flex tw-flex-col tw-mx-auto"
  >
    <div
      class="tw-flex tw-flex-col tw-mx-auto"
      style="max-width: 768px; width: 100%"
    >
      <h2 class="question-title-v2 tw-mb-6 tw-text-center">
        {{ question.question || question.title }}
      </h2>
      <div class="tw-flex tw-flex-col tw-gap-3 tw-mb-4">
        <button
          v-for="item in question.answerlist"
          :key="item.id"
          type="button"
          class="treatment-dose-option tw-w-full tw-py-3 tw-px-4 tw-text-base tw-text-center tw-transition-colors"
          :class="answer === item.id ? 'is-active' : ''"
          :disabled="composite"
          @click="onSelect(item.id)"
        >
          {{ item.name }}
        </button>
      </div>
      <div
        v-if="showUnsureTextarea"
        class="tw-mb-4"
      >
        <b-form-textarea
          id="treatment-dose-unsure-textarea"
          v-model="otherAnswer"
          class="onboarding-textarea-v2 fs-exclude"
          rows="4"
          max-rows="6"
          placeholder="Share what's on your mind so your doctor can help."
        />
      </div>
      <div class="tw-text-center">
        <b-button
          variant="info"
          size="lg"
          pill
          :disabled="!canSubmit"
          style="width: 100%"
          @click="onContinue"
        >
          Continue
        </b-button>
      </div>
    </div>
  </b-col>
</template>

<script>
export default {
  props: {
    question: { type: Object, required: true },
    composite: { type: Boolean, default: false },
  },
  data() {
    return { answer: null, otherAnswer: '' };
  },
  computed: {
    selected() {
      if (!Array.isArray(this.question.answerlist)) return null;
      return (
        this.question.answerlist.find(i => i.id === this.answer) || null
      );
    },
    showUnsureTextarea() {
      const o = this.selected;
      if (!o) return false;
      const id = String(o.id || '').toLowerCase();
      const name = String(o.name || '').toLowerCase();
      return id === 'unsure' || name.includes('not sure');
    },
    canSubmit() {
      if (!this.answer) return false;
      if (this.showUnsureTextarea && !this.otherAnswer.trim()) return false;
      return true;
    },
  },
  watch: {
    question: {
      handler() {
        this.answer = this.question.answer ?? null;
        this.otherAnswer = Array.isArray(this.question.others)
          ? this.question.others[0] || ''
          : '';
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onSelect(id) {
      this.answer = id;
      if (!this.showUnsureTextarea) this.otherAnswer = '';
    },
    onContinue() {
      if (!this.canSubmit) return;
      const others = this.showUnsureTextarea
        ? this.otherAnswer.trim()
        : undefined;
      this.$emit('submitAnswer', {
        id: this.question.id,
        answer: this.answer,
        answerBody: this.selected,
        others,
      });
    },
  },
};
</script>

<style scoped>
.treatment-dose-option {
  background-color: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  font-family: inherit;
  color: #2c2660;
  cursor: pointer;
}
.treatment-dose-option:hover:not(:disabled) {
  border-color: #a783ff;
}
.treatment-dose-option.is-active {
  border-color: #a783ff;
  background-color: #f5f0ff;
}
.treatment-dose-option:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
